module.exports = __webpack_public_path__ + "static/media/008_onecolor_trademark_5_28_2015_final.png.001.1c9fa101.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/008_onecolor_trademark_5_28_2015_final.png.001.png
// module id = 387
// module chunks = 0